import { lazy } from 'react';

export const CountryList = lazy(() => import('./country/CountryList'));
export const StateList = lazy(() => import('./state/StateList'));
export const CityList = lazy(() => import('./city/CityList'));
export const DepartmentList = lazy(() => import('./department/DepartmentList'));
export const DesignationList = lazy(() => import('./designation/DesignationList'));
export const LocationList = lazy(() => import('./location/LocationList'));
export const ComponentList = lazy(() => import('./component/ComponentList'));
export const MakeList = lazy(() => import('./make/MakeList'));
export const EquipmentList = lazy(() => import('./equipment/EquipmentList'));
export const EquipmentAssignList = lazy(() => import('./equipmentAssign/EquipmentAssignList'));
export const ObjectConditionList = lazy(() => import('./objectCondition/ObjectConditionList'));
export const ObjectList = lazy(() => import('./object/ObjectList'));